import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Chip } from '@mui/material'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { TariffStatusType } from '../models/types'

const useStyles = makeStyles()(theme => ({
  active: {
    backgroundColor: theme.palette.tariff.status.active.background,
    color: theme.palette.tariff.status.active.text,
    padding: theme.spacing(0.5),
  },
  inactive: {
    backgroundColor: theme.palette.tariff.status.inactive.background,
    color: theme.palette.tariff.status.inactive.text,
    padding: theme.spacing(0.5),
  },
  expired: {
    backgroundColor: theme.palette.tariff.status.expired.background,
    color: theme.palette.tariff.status.expired.text,
    padding: theme.spacing(0.5),
  },
}))

interface TariffsStatusChipProps {
  status: TariffStatusType
}

/**
 *  Tariffs status chip component.
 *  @param status - one of types from TariffStatusType
 */
export const TariffsStatusChip: React.VFC<TariffsStatusChipProps> = ({ status }) => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()

  const statusMap: Record<TariffStatusType, string> = {
    active: classes.active,
    expired: classes.expired,
    inactive: classes.inactive,
    'not-in-use': classes.inactive,
  }

  return <Chip size="small" label={t(`emobility.tariffs.tariff-status-${status}`)} className={statusMap[status]} />
}
